// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"0226de2c23e4ec8f6131","293":"c755f8648e7a5d27d98d","518":"a1625395517900627ea7","779":"e4e8e149bf264dd3eaaa"}[chunkId] + ".js";
};